var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelinePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1831 31C24.1912 31 30.6831 24.5081 30.6831 16.5C30.6831 8.49187 24.1912 2 16.1831 2C8.17498 2 1.68311 8.49187 1.68311 16.5C1.68311 24.5081 8.17498 31 16.1831 31Z",
    fill: "#1B3764",
    stroke: "#1B3764",
    strokeWidth: 2.83465,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2111 21.64V17.464H11.0831V15.736H15.2111V11.56H17.0351V15.736H21.1631V17.464H17.0351V21.64H15.2111Z",
    fill: "#98C4C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinePlus);
export default __webpack_public_path__ + "static/media/timeline-plus.e27903b072d55985b89c820aa169a155.svg";
export { ForwardRef as ReactComponent };